import { gql } from '@apollo/client';

export const GET_REMAINING_TIER_2 = gql`
  query($tier2s: [String!]) {
    categoriesTier2S(where: { sys_name: { notIn: $tier2s } }) {
      sys_name
      name
    }
  }
`;
